import { Content, Header, Page, Progress, ResponseErrorPanel } from "@backstage/core-components";
import { useApi } from "@backstage/core-plugin-api";
import { catalogApiRef, useEntity } from "@backstage/plugin-catalog-react";
import React from "react";
import useAsync from "react-use/esm/useAsync";
import { GetEntitiesResponse } from '@backstage/catalog-client'
import { DomainCard } from "../home";
import { Grid } from "@material-ui/core";
import { stringifyEntityRef } from "@backstage/catalog-model";
import CustomerLoyaltyAPIDocumentation from "./Docs/CustomerLoyaltyApiDocs";


export const DomainPage = () => {
    const { entity } = useEntity()
    const catalogApi = useApi(catalogApiRef)
    const { value, loading, error } = useAsync(async (): Promise<GetEntitiesResponse> => {
        const response = catalogApi.getEntities({ filter: [{ kind: 'API' }] })
        return response
    })

    if (loading) {
        <Progress />
    }
    if (error) {
        return (<ResponseErrorPanel error={error || { name: "DomainsNotFoud", message: "Unable to retrieve any domains" }}></ResponseErrorPanel>)
    }
    return (
        <Page themeId="home">
            <Header title={entity.metadata.name} pageTitleOverride="Home"></Header>
            <Content>
                <Grid container spacing={3} alignItems="stretch">
                    {value && value.items.map(e => {
                        if (e.relations) {
                            if (e.relations.filter(rel => rel.targetRef === stringifyEntityRef(entity)).length > 0) {
                                return (
                                    <Grid item md={6}>
                                        <DomainCard name={e.metadata.name} description={e.metadata.description || "No Description Found"} kind="api"></DomainCard>
                                    </Grid>
                                )
                            }
                        }
                        return (
                            <></>
                        )
                    })}
                </Grid>
                {entity.metadata.name == 'Customer' && (
                    <CustomerLoyaltyAPIDocumentation />
                )}
            </Content>
        </Page>
    )
}